module.exports = __webpack_public_path__ + "static/media/dispatch-thumbnail.ffe24a08.jpg";